import React, { useContext } from 'react'
import Tippy from '@tippyjs/react'

import { UserContext } from './UserContext'

const CheckBox = ({ tooltipContent, label, cbChanged, checked, textSide,textColor }) => { //textSide is either left or right. default left

    const { checkboxZoom } = useContext(UserContext)

    var cb_text_color = textColor;


    if (cb_text_color === undefined){
        cb_text_color = 'white';
    }
    var ttc = '';
    var ttp = 'right';
    if (tooltipContent !== undefined) {
        ttc = tooltipContent.slice(2);
        switch (tooltipContent.substring(0, 1)) {
            case 'r': ttp = 'right'; break;
            case 'l': ttp = 'left'; break;
            case 't': ttp = 'top'; break;
            case 'b': ttp = 'bottom'; break;
            default: break;
        }
    }



    return (

        <Tippy placement={ttp} content={
            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                {ttc}
            </div>
        }>
            {textSide === 'right'
                ?
                <div style={{ whiteSpace: "nowrap", display: 'flex', alignItems: 'center', backgroundColor: 'transparent' }}>

                    <div style={{ height: '100%', backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }} >
                        <input type="checkbox" value={label} onChange={cbChanged} checked={checked} style={{ zoom: checkboxZoom }} />
                    </div>

                    {label !== 'email_reminder' && label !== 'popup_reminder' &&
                        <div style={{ height: '100%', backgroundColor: 'transparent' }} >
                            <span style={{ color: cb_text_color, }}>{label}</span>
                        </div>
                    }


                </div>
                :
                <div style={{ whiteSpace: "nowrap", display: 'flex', alignItems: 'center', backgroundColor: 'transparent' }}>
                    {label !== 'email_reminder' && label !== 'popup_reminder' &&
                        <div style={{ height: '100%', backgroundColor: 'transparent' }} >
                            <span style={{ color: cb_text_color, }}>{label}</span>
                        </div>
                    }
                    <div style={{ height: '100%', backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }} >
                        <input type="checkbox" value={label} name={label} onChange={cbChanged} checked={checked} style={{ zoom: checkboxZoom }} />
                    </div>

                </div>
            }
        </Tippy>
    )
}

export default CheckBox
